const nextButtonText = (props, isLast=true) => {
  const finishText = props.nextId ? 'Next Exercise' : 'Finish'
  return isLast ? finishText : 'Next Question';
}

export default nextButtonText;
